export default __webpack_public_path__ + "static/media/Personal data-cuate.b5216693.svg";